import { render, staticRenderFns } from "./StarTab.vue?vue&type=template&id=60dc0008&scoped=true"
import script from "./StarTab.vue?vue&type=script&lang=js"
export * from "./StarTab.vue?vue&type=script&lang=js"
import style0 from "./StarTab.vue?vue&type=style&index=0&id=60dc0008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc0008",
  null
  
)

export default component.exports